"use client"

import { useTelegram } from "../hooks/useTelegram"
import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { apiClient } from "../api/client"
import type { UserInfo } from "../types"
import "./Home.css"

export const Home = () => {
  const { user, webApp } = useTelegram()
  const navigate = useNavigate()
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null)

  useEffect(() => {
    apiClient.getUserInfo().catch(() => null).then(setUserInfo)
  }, [])

  const photoUrl = (user as any)?.photo_url
  const initials = user?.first_name
    ? user.first_name.charAt(0).toUpperCase() + (user.last_name?.charAt(0).toUpperCase() ?? "")
    : "?"

  return (
    <div className="home">
      {/* Header */}
      <div className="home-header">
        <div className="home-header-left">
          <div className="home-avatar">
            {photoUrl
              ? <img src={photoUrl} alt="avatar" />
              : <span>{initials}</span>
            }
            <div className={`home-avatar-dot ${userInfo?.isBusinessConnected ? "online" : "offline"}`} />
          </div>
          <div className="home-header-info">
            <div className="home-header-name">
              {user?.first_name}{user?.last_name ? ` ${user.last_name}` : ""}
            </div>
            <div className="home-header-sub">
              {user?.username ? `@${user.username}` : `ID ${user?.id}`}
            </div>
          </div>
        </div>
        <div className={`home-status-badge ${userInfo?.isBusinessConnected ? "active" : ""}`}>
          {userInfo?.isBusinessConnected ? "Business ✓" : "Business —"}
        </div>
      </div>


      {/* Cards */}
      <div className="home-cards">
        <button className="home-card home-card--primary" onClick={() => navigate("/chats")}>
          <div className="home-card-icon">
            <ChatsIcon />
          </div>
          <div className="home-card-content">
            <div className="home-card-title">Мои чаты</div>
            <div className="home-card-desc">Перехваченные переписки</div>
          </div>
          <ChevronIcon />
        </button>

        <button className="home-card" onClick={() => navigate("/accounts")}>
          <div className="home-card-icon">
            <AccountIcon />
          </div>
          <div className="home-card-content">
            <div className="home-card-title">Аккаунты</div>
            <div className="home-card-desc">Управление аккаунтами</div>
          </div>
          <ChevronIcon />
        </button>

        <button className="home-card" onClick={() => webApp?.openTelegramLink("https://t.me/SaverrModBot")}>
          <div className="home-card-icon">
            <BotIcon />
          </div>
          <div className="home-card-content">
            <div className="home-card-title">Бот</div>
            <div className="home-card-desc">Открыть в Telegram</div>
          </div>
          <ChevronIcon />
        </button>
      </div>
    </div>
  )
}


const ChatsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
)

const AccountIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13 19.79 19.79 0 0 1 1.6 4.41 2 2 0 0 1 3.58 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.18 6.18l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
)

const BotIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="10" rx="2" />
    <circle cx="12" cy="5" r="2" />
    <path d="M12 7v4M8 16h0M16 16h0" />
  </svg>
)


const ChevronIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
)
